import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import profileApi from "../../../api/profile";
import authHelper from '../../../helpers/auth';

const defaultState = () => ({
    profile: [],
    konfirmResponse: {},
    responSukses: '',
    responUpload: ''
});

const state = defaultState();

const getters = {};

const mutations = {
    listProfile(state, data) {
        state.profile = []
        state.profile = data;
    },
    saveConfirmResponse(state, data) {
        state.konfirmResponse = {};
        state.konfirmResponse = data;
    },
    konfirmasiSukses(state, data) {
        state.responSukses = '';
        state.responSukses = data;
    },
    listResponseUpload(state, data) {
        state.responUpload = ''
        if (data == 'sukses') {
            state.responUpload = ''
        } else {
            state.responUpload = data.image + ',' + data.size;
        }
    },
    clearDataProfile(state) {
        Object.assign( state , defaultState())
    },
    savePin(state, data) {
        //console.log('profile.js', data)
        authHelper.updatePin(data)
    }
};
const actions = {
    getProfile({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        profileApi.getDataProfile().then(({ data: { data: { profile } } }) => {
            commit("listProfile", profile);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },
    async addProfile({ commit }, value) {
        commit("konfirmasiSukses", '');
        commit(PROGRESS_START, null, { root: true });
        await profileApi.addProfile(value).then(res => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
        });
    },
    async updateProfileKasir({ commit }, value) {
        commit("konfirmasiSukses", '');
        commit(PROGRESS_START, null, { root: true });
        await profileApi.updateProfileKasir(value).then(res => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
        });
    },
    async updateProfileUtama({ commit }, value) {
        commit("konfirmasiSukses", '');
        commit(PROGRESS_START, null, { root: true });
        await profileApi.updateProfileUtama(value).then(res => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
        })
        .catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
        });
    },
    async deleteProfile({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        await profileApi.deleteProfile(value).then(res => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            dispatch('getProfile');
        })
        .catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
        });
    },
    async uploadImageUtama({ dispatch, commit }, params) {
        await profileApi.uploadImageUtama(params).then((res) => {
            if (res.data.code == 200) {
                commit('listResponseUpload', 'sukses')
                dispatch('getProfile');
            } else {
                commit('listResponseUpload', res.data.data)
            }
        }).catch(err => {
            const data = err.response.data
            commit("saveConfirmResponse", data);
        });
    },
    async uploadImageKasir({ commit, dispatch }, params) {
        await profileApi.uploadImageKasir(params).then((res) => {
            if (res.data.code == 200) {
                commit('listResponseUpload', 'sukses')
                dispatch('getProfile');
            } else {
                commit('listResponseUpload', res.data.data)
            }

        }).catch(err => {
            const data = err.response.data
            commit("saveConfirmResponse", data);
        });
    },
    async saveAddress({ commit }, params) {
        await profileApi.saveAddress(params).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
        }).catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
        });
    },
    async savePassword({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        await profileApi.updateProfilePassword(params).then((res) => {
            const data = res.data;
            commit("konfirmasiSukses", data);
            commit("saveConfirmResponse", {});
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(err => {
            const data = err.response.data
            if(data.message == 'error_validation'){
                commit("saveConfirmResponse", data.data);
            } else {
                commit("saveConfirmResponse", data);
            }
            commit("konfirmasiSukses", '');
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },
    async requestOtpCode({ commit }, params) {
        await profileApi.requestOtpCode(params).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            commit("saveConfirmResponse", {});
        }).catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
            commit("konfirmasiSukses", '');
        });
    },
    async setPin({ commit }, params) {
        await profileApi.setPin(params).then((res) => {
            const data = res.data.code;
            commit("konfirmasiSukses", data);
            commit("savePin", true);
            commit("saveConfirmResponse", {});
        }).catch(err => {
            const data = err.response.data.data
            commit("saveConfirmResponse", data);
            commit("konfirmasiSukses", '');
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};